import { useState } from 'react';
import ImageModal from './ImageModal';
import ImageViewerModal from './ImageViewerModal';
import ImageContainer from './image/ImageContainer';
import ImageActions from './image/ImageActions';
import GenerationTimer from './image/GenerationTimer';

interface Message {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
  image?: string;
  imageId?: string;
  previewImage?: string;
  isGeneratingImage?: boolean;
  imageGenerationStartTime?: number;
  model?: string;
  userPrompt?: string;
  fullPrompt?: string;
  promptId?: string;
  rating?: 'thumbs_up' | 'thumbs_down' | null;
  error?: string;
  hasError?: boolean;
}

interface ImageDisplayProps {
  message: Message;
  sessionTitle?: string;
  sessionId?: string;
  onRegenerate?: (model: string, prompt: string, promptId?: string, modelObject?: any) => void;
  allImageMessages?: Message[];
  currentImageIndex?: number;
}

export default function ImageDisplay({ message, sessionTitle, sessionId, onRegenerate, allImageMessages, currentImageIndex }: ImageDisplayProps) {
  const { imageId, image, previewImage, isGeneratingImage, imageGenerationStartTime } = message;
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [isEditorOpen, setIsEditorOpen] = useState(false);

  if (!imageId && !image && !previewImage && !isGeneratingImage) return null;

  return (
    <div className="flex flex-col w-full aspect-square sm:max-w-[320px] md:max-w-[400px] lg:max-w-[450px] xl:max-w-[500px]">
      <ImageContainer
        message={message}
        sessionTitle={sessionTitle}
        onImageClick={() => setIsViewerOpen(true)}
      />
      {/* Show timer during generation, hide actions */}
      {isGeneratingImage ? (
        <GenerationTimer startTime={imageGenerationStartTime} isGenerating={isGeneratingImage} />
      ) : (
        <ImageActions
          message={message}
          sessionTitle={sessionTitle}
          onRegenerate={onRegenerate}
          onEdit={() => setIsEditorOpen(true)}
          isGenerating={isGeneratingImage}
        />
      )}
      <ImageViewerModal
        isOpen={isViewerOpen}
        onClose={() => setIsViewerOpen(false)}
        messages={allImageMessages || [message]}
        currentIndex={currentImageIndex || 0}
        sessionTitle={sessionTitle}
        onRegenerate={onRegenerate}
        onOpenEditor={() => setIsEditorOpen(true)}
      />
      <ImageModal
        isOpen={isEditorOpen}
        onClose={() => setIsEditorOpen(false)}
        imageId={imageId}
        imageTitle={sessionTitle}
      />
    </div>
  );
}